export default {
	loginScript: 'https://login.szn.cz/js/api/3/login.js'
};
